var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEventDefaultImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 152,
    viewBox: "0 0 152 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30_2270)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 152,
    height: 152,
    rx: 10,
    fill: "#FFA800"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6728 36.3608C34.9399 36.3608 34.2369 36.6494 33.7186 37.163C33.2003 37.6766 32.9092 38.3732 32.9092 39.0996V93.2376C32.9092 93.9639 33.2003 94.6606 33.7186 95.1742C34.2369 95.6878 34.9399 95.9763 35.6728 95.9763H87.321L83.9909 82.9167C83.937 82.7045 83.9396 82.4821 83.9984 82.2712C84.0573 82.0603 84.1704 81.8682 84.3266 81.7136C84.4829 81.559 84.677 81.4473 84.8899 81.3893C85.1028 81.3314 85.3272 81.3292 85.5412 81.383L111.115 87.7848V39.0996C111.115 38.3732 110.823 37.6766 110.305 37.163C109.787 36.6494 109.084 36.3608 108.351 36.3608H35.6728ZM76.7101 56.3482C76.1603 56.3482 75.6331 56.5646 75.2444 56.9498C74.8557 57.335 74.6373 57.8574 74.6373 58.4022C74.6373 58.947 74.8557 59.4694 75.2444 59.8546C75.6331 60.2399 76.1603 60.4563 76.7101 60.4563H101.522C102.072 60.4563 102.599 60.2399 102.988 59.8546C103.376 59.4694 103.595 58.947 103.595 58.4022C103.595 57.8574 103.376 57.335 102.988 56.9498C102.599 56.5646 102.072 56.3482 101.522 56.3482H76.7101ZM74.6373 67.9878C74.6373 67.443 74.8557 66.9206 75.2444 66.5354C75.6331 66.1502 76.1603 65.9337 76.7101 65.9337H93.8211C94.3708 65.9337 94.898 66.1502 95.2867 66.5354C95.6755 66.9206 95.8938 67.443 95.8938 67.9878C95.8938 68.5326 95.6755 69.055 95.2867 69.4402C94.898 69.8254 94.3708 70.0418 93.8211 70.0418H76.7101C76.1603 70.0418 75.6331 69.8254 75.2444 69.4402C74.8557 69.055 74.6373 68.5326 74.6373 67.9878Z",
    fill: "url(#paint0_linear_30_2270)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.5033 58.691C42.5033 57.9647 42.7945 57.268 43.3128 56.7544C43.8311 56.2408 44.534 55.9523 45.267 55.9523H64.8556C65.5886 55.9523 66.2915 56.2408 66.8098 56.7544C67.3281 57.268 67.6193 57.9647 67.6193 58.691V83.1658C67.6193 83.8921 67.3281 84.5887 66.8098 85.1023C66.2915 85.6159 65.5886 85.9045 64.8556 85.9045H45.2656C44.5326 85.9045 43.8297 85.6159 43.3114 85.1023C42.7931 84.5887 42.502 83.8921 42.502 83.1658V58.691H42.5033Z",
    fill: "url(#paint1_linear_30_2270)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9092 39.0996C32.9092 38.3732 33.2003 37.6766 33.7186 37.163C34.2369 36.6494 34.9399 36.3608 35.6728 36.3608H108.351C109.084 36.3608 109.787 36.6494 110.305 37.163C110.823 37.6766 111.115 38.3732 111.115 39.0996V48.1018H32.9092V39.0996Z",
    fill: "url(#paint2_linear_30_2270)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.541 81.3817C85.3269 81.3281 85.1025 81.3304 84.8897 81.3886C84.6768 81.4467 84.4828 81.5586 84.3267 81.7133C84.1706 81.8681 84.0576 82.0603 83.999 82.2712C83.9403 82.4822 83.9379 82.7046 83.992 82.9167L91.3626 111.827C91.4178 112.043 91.5299 112.241 91.6875 112.401C91.8451 112.561 92.0426 112.676 92.2598 112.735C92.477 112.795 92.7062 112.796 92.9241 112.739C93.142 112.682 93.3408 112.569 93.5003 112.412L100.017 105.954C100.135 105.836 100.276 105.743 100.431 105.679C100.586 105.616 100.752 105.583 100.919 105.583C101.087 105.583 101.253 105.616 101.408 105.679C101.562 105.743 101.703 105.836 101.822 105.954L111.753 115.795C112.25 116.288 113.059 116.288 113.556 115.795L118.716 110.681C118.955 110.444 119.089 110.122 119.089 109.787C119.089 109.452 118.955 109.131 118.716 108.894L108.785 99.052C108.546 98.815 108.411 98.4936 108.411 98.1585C108.411 97.8234 108.546 97.502 108.785 97.265L115.303 90.8057C115.462 90.6476 115.576 90.4506 115.633 90.2347C115.691 90.0188 115.689 89.7916 115.629 89.5763C115.57 89.3611 115.453 89.1654 115.292 89.0092C115.131 88.8531 114.931 88.742 114.713 88.6872L85.541 81.3817Z",
    fill: "url(#paint3_linear_30_2270)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_30_2270",
    x1: 32.9092,
    y1: 38.9407,
    x2: 89.9926,
    y2: 90.7839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_30_2270",
    x1: 46.711,
    y1: 61.0189,
    x2: 63.2459,
    y2: 84.4355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.41
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_30_2270",
    x1: 37.4333,
    y1: 48.1018,
    x2: 111.093,
    y2: 38.6479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_30_2270",
    x1: 98.4044,
    y1: 114.189,
    x2: 105.586,
    y2: 81.3146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30_2270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 152,
    height: 152,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventDefaultImage);
export default __webpack_public_path__ + "static/media/eventDefaultImage.fbd89c4d7813b52bb15154c780f7d29f.svg";
export { ForwardRef as ReactComponent };